import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function Sidebar() {
  const location = useLocation(); // Get current location
  const navigate = useNavigate();

  useEffect(() => {
    // Function to toggle sidebar visibility on button click
    const toggleSidebar = () => {
      document.body.classList.toggle("toggle-sidebar");
    };

    // Event listener for toggle button click
    const sidebarButton = document.querySelector(".toggle-sidebar-btn");
    if (sidebarButton) {
      sidebarButton.addEventListener("click", toggleSidebar);
    }

    return () => {
      // Cleanup: remove event listener when component unmounts
      if (sidebarButton) {
        sidebarButton.removeEventListener("click", toggleSidebar);
      }
    };
  }, []);

  return (
    <>
      <aside id="sidebar" className="sidebar">
        <ul className="sidebar-nav" id="sidebar-nav">

          {/* Dashboard Nav */}
          <li className="nav-item">
            <a
              className={`nav-link ${location.pathname === "/admin/dashboard" ? "active" : "collapsed"}`}
              role="button"
              onClick={() => navigate("/admin/dashboard")}
            >
              <i className="bi bi-grid"></i>
              <span>Dashboard</span>
            </a>
          </li>

          {/* Unicommerce Nav */}
          <li className="nav-item">
            <a
              className={`nav-link ${location.pathname === "/admin/unicommerce" ? "active" : "collapsed"}`}
              role="button"
              onClick={() => navigate("/admin/unicommerce")}
            >
              <i className="bi bi-search"></i>
              <span>Uniware Get Data By Search</span>
            </a>
          </li>

          {/* Unicommerce Nav */}
          <li className="nav-item">
            <a
              className={`nav-link ${location.pathname === "/admin/uniware" ? "active" : "collapsed"}`}
              role="button"
              onClick={() => navigate("/admin/uniware")}
            >
              <i className="bi bi-database"></i>
              <span>Uniware Data</span>
            </a>
          </li>

          {/* Courier Department */}
          {/* <li className="nav-item">
            <a
              className={`nav-link ${location.pathname === "/admin/courier" ? "active" : "collapsed"}`}
              role="button"
              onClick={() => navigate("/admin/courier")}
            >
              <i className="bi bi-truck"></i>
              <span>Courier Department</span>
            </a>
          </li> */}

          {/* Undelivered List */}
          {/* <li className="nav-item">
            <a
              className={`nav-link ${location.pathname === "/admin/undelivered" ? "active" : "collapsed"}`}
              role="button"
              onClick={() => navigate("/admin/undelivered")}
            >
              <i className="bi bi-x-circle"></i>
              <span>Undelivered List</span>
            </a>
          </li> */}

          {/* DTDC_Courier Nav */}
          {/* <li
            className={`nav-item ${location.pathname === "/admin/dtdc_courier" ? "active" : ""
              }`}
          >
            <a className="nav-link collapsed" role="button" onClick={() => navigate("/admin/dtdc_courier")}>
              <i className="bi bi-grid"></i>
              <span>DTDC Courier</span>
            </a>
          </li> */}

          {/* Shree_Nandan_Courier Nav */}
          {/* <li
            className={`nav-item ${location.pathname === "/admin/shree_nandan_courier"
              ? "active"
              : ""
              }`}
          >
            <a
              className="nav-link collapsed" role="button"
              onClick={() => navigate("/admin/shree_nandan_courier")}
            >
              <i className="bi bi-grid"></i>
              <span>Shree Nandan Courier</span>
            </a>
          </li> */}

          {/* Shree Tirupati Courier Nav */}
          <li className="nav-item">
            <a
              className={`nav-link ${location.pathname === "/admin/shree_tirupati_courier" ? "active" : "collapsed"}`}
              role="button"
              onClick={() => navigate("/admin/shree_tirupati_courier")}
            >
              <i className="bi bi-envelope"></i>
              <span>Shree Tirupati Courier</span>
            </a>
          </li>
          {/* Excel Upload Nav */}
          <li className="nav-item">
            <a
              className={`nav-link ${location.pathname === "/admin/excel-upload" ? "active" : "collapsed"}`}
              role="button"
              onClick={() => navigate("/admin/excel-upload")}
            >
              <i className="bi bi-upload"></i>
              <span>Excel Data</span>
            </a>
          </li>
          {/* <li
            className={`nav-item ${location.pathname === "/admin/inquiry" ? "active" : ""
              }`}
          >
            <a className="nav-link collapsed" role="button" onClick={() => navigate("/admin/inquiry")}>
              <i className="bi bi-grid"></i>
              <span>InquiryList</span>
            </a>
          </li>

          <li
            className={`nav-item ${location.pathname === "/admin/recourier" ? "active" : ""
              }`}
          >
            <a className="nav-link collapsed" role="button" onClick={() => navigate("/admin/recourier")}>
              <i className="bi bi-grid"></i>
              <span>Recourier List</span>
            </a>
          </li>

          <li
            className={`nav-item ${location.pathname === "/admin/refund" ? "active" : ""
              }`}
          >
            <a className="nav-link collapsed" role="button" onClick={() => navigate("/admin/refund")}>
              <i className="bi bi-grid"></i>
              <span>Refund List</span>
            </a>
          </li>

          <li
            className={`nav-item ${location.pathname === "/admin/resolve" ? "active" : ""
              }`}
          >
            <a className="nav-link collapsed" role="button" onClick={() => navigate("/admin/resolve")}>
              <i className="bi bi-grid"></i>
              <span>Resolved List</span>
            </a>
          </li> */}

          {/* All Query List */}
          {/* <li className="nav-item">
            <a
              className={`nav-link ${location.pathname === "/admin/all" ? "active" : "collapsed"}`}
              role="button"
              onClick={() => navigate("/admin/all")}
            >
              <i className="bi bi-list-ul"></i>
              <span>All Query List</span>
            </a>
          </li> */}

          {/* Logout with Confirmation */}
          <li className="nav-item">
            <a
              className="nav-link collapsed"
              role="button"
              onClick={() => {
                const confirmLogout = window.confirm("Are you sure you want to logout?");
                if (confirmLogout) {
                  sessionStorage.clear();
                  localStorage.removeItem("userData");
                  navigate("/login");
                }
              }}
            >
              <i className="bi bi-box-arrow-right"></i>
              <span>Logout</span>
            </a>
          </li>
        </ul>
      </aside>
    </>
  );
}

export default Sidebar;
